module.exports = __webpack_public_path__ + "img/logo-v2.236f4ad7.png";